import angular from 'angular';

export default angular.module('shared').constant('navigationConstants', {
    main: {
        label: 'Overview',
        sref: 'license_overview',
        value: 'license_overview'
    },
    license: {
        label: 'License Management',
        sref: 'license_manage',
        value: 'license_manage'
    },
    billing: {
        label: 'Billing',
        sref: 'billing_overview',
        value: 'billing_overview'
    },
    support: {
        label: 'Support',
        sref: 'support_overview',
        value: 'support_overview'
    },
    settings: {
        label: 'Settings',
        sref: 'settings',
        value: 'settings',
        subNavigation: [
            {
                value: 'permissions',
                label: 'Permissions',
                sref: 'settings_permission'
            },
            {
                value: 'accountAuthentication',
                label: 'Account Authentication',
                sref: 'settings_accountAuthentication'
            },
            {
                value: 'userProvisioning',
                label: 'User Provisioning',
                sref: 'settings_userProvisioning'
            }
        ]
    }
});



// WEBPACK FOOTER //
// ./modules/shared/constants/navigation.constant.js